<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  <div class='global-panel' v-loading.body="loading.main">
    <div class="global-header">
      <div class="global-title">综合信息发布</div>
      <div class='global-tbar'>
        <el-input size="small" v-model="condition.taskName" placeholder="标题"></el-input>
        <el-button size="small" type="primary"  @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <div class="global-paging" v-show="paging.allNum > paging.everySize" >
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" v-for='data in dataList' style="padding-bottom: 10px">
          <el-card class="box-card">
            <template #header>
              <div class="card-header">
                <span style="font-size:14px">{{data.taskName}}</span>
                <el-button v-if="data.taskStatus==='进行中'" class="button" size="small" type="success" @click="scoreQuery(data)">查 看</el-button>
              </div>
            </template>
            <div style="padding-bottom: 10px" class="course-desc">
            <span>状态：</span>
            <span v-if="data.taskStatus==='未开始'" style ="color:blue">{{data.taskStatus}}</span>
            <span v-if="data.taskStatus==='进行中'" style ="color:red">{{data.taskStatus}}</span>
            <span v-if="data.taskStatus==='已结束'" style ="color:grey">{{data.taskStatus}}</span>
            <span v-if="data.taskStatus==='已冻结'" style ="color:grey">{{data.taskStatus}}</span>
            </div>
            <div style="padding-bottom: 30px" class="course-desc">
              <span>说明：</span>
              {{data.taskDesc}}
            </div>
            <div><span style="color:green">开始时间：</span>
              <el-date-picker size="small" readonly
              v-model="data.startTime"
              type="datetime"/>
            </div>
            <div style="padding-bottom: 10px"><span style="color:red">结束时间：</span>
              <el-date-picker size="small" readonly
                v-model="data.endTime"
                type="datetime"/>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- 分页  -->
      <div v-show="paging.allNum > paging.everySize" class="global-paging">
        <hr/>
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
    </div>
  </div>
  <el-dialog :visible.sync="visible.choose" width="70%" v-loading="loading.choose" fullscreen :close-on-click-modal="false" :close-on-press-escape="false">
    <el-row>
      <div class="global-title"><span>{{currentRecord.taskName}}</span></div>
    </el-row>
    <el-row>
      <div style="padding-bottom: 30px">
        <span>欢迎，{{clazz.clazzName}} | {{student.studentName}}</span>
      </div>
    </el-row>
    <el-row>
      <div style="padding-bottom: 30px">
        <span>描述：</span>
        <span v-html="currentRecord.taskDesc"></span>
      </div>
    </el-row>
    <el-row>
      <div style="padding-bottom: 15px"><span style="color:green">开始时间：</span>
        <el-date-picker size="small" readonly
                        v-model="currentRecord.startTime"
                        type="datetime"/>
      </div>
      <div style="padding-bottom: 20px"><span style="color:red">结束时间：</span>
        <el-date-picker size="small" readonly
                        v-model="currentRecord.endTime"
                        type="datetime"/>
      </div>
    </el-row>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" style="padding-bottom: 10px">
        <el-card class="box-card">
          <div style="padding-bottom: 15px;" class="course-detial-desc">
            <div style="height:auto;padding-bottom: 10px;" v-for='score in scoreList' >
              {{score.subjectName}}：<span style="color: red" v-html="score.score"></span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
    <el-button @click="visible.choose = false" type="danger" size="small" >关 闭</el-button>
  </span>
  </el-dialog>
</div>

</template>

<script>

export default {
  name: 'ScoreQuery',
  data () {
    return {
      // 遮罩
      loading: {main: false, choose: false},
      // 可见
      visible: {choose: false},
   	  // 检索条件
      condition: {taskName:null},
      // 课程列表
      scoreList: [],
      // 当前记录
      currentRecord: {},
      // 学生
      student: {},
      // 班级
      clazz: {},
   	  // 分页
      paging: {currPage: 1, everySize: 10, allNum: 0}
    }
  },

  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
    vm.findByCondition();
    console.info(this.$route.params.type)
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.findByCondition();
  },
  methods: {
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      params.type = this.$route.params.type
      // 请求后台
      vm.$http.get('rest/scoreTask/scoreQueryList', {params: params}).then(response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 更新数据
        vm.dataList = response.body.taskList;
        vm.paging = response.body.pagingBean;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    scoreQuery: function (record) {
      var vm = this;
      vm.currentRecord = record;
      vm.visible.choose = true;
      vm.loading.choose = true;
      vm.$http.get('rest/scoreTask/scoreQuery', {params: {"taskId":vm.currentRecord.id}}).then(response => {
        vm.loading.choose = false;
        vm.scoreList = response.body.scoreList;
        vm.currentRecord = response.body.task;
        vm.student = response.body.student;
      }, response => {
        // 关闭遮罩
        vm.loading.choose = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    }
  }
}
</script>

<style>
  .global-main {
    padding: 5px 0;
    position: relative;
    overflow: auto;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
  }
  .course-desc {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 2em;
    max-height: 2em;
  }
  .course-detail-desc {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 3em;
    max-height: 3em;
  }
</style>



// WEBPACK FOOTER //
// src/app/ScoreQuery.vue